import { render, staticRenderFns } from "./SetupSuratTugas.vue?vue&type=template&id=a9353b78"
import script from "./SetupSuratTugas.vue?vue&type=script&lang=js"
export * from "./SetupSuratTugas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports